import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { PropertyOwnerModel } from '../models/propertyOwnerModel';

@Component({
  selector: 'app-ownershipsummary',
  templateUrl: './ownershipsummary.component.html',
  styleUrls: ['./ownershipsummary.component.scss']
})
export class OwnershipsummaryComponent implements OnInit {

  public owners : Array<PropertyOwnerModel>;
  constructor(private router: Router, private data: DataService ) {
    this.owners = data.SelectedProperty.owners;
  }

  ngOnInit(): void {
    this.data.events.subscribe((e)=>{
      switch(e){
        case "back":{
          this.data.showBackButton = false;
          this.data.backPath = ""
          this.router.navigate([this.data.backPath],{skipLocationChange: false});
        }
      }
    })
  }

  onDetailsClicked(ownerid : PropertyOwnerModel){
    this.data.showBackButton = true;
    this.data.backPath = "ownershipsummary"
    this.data.SelectedOwner = ownerid;
    this.router.navigate(["ownerdetails"],{skipLocationChange: false});
  }

}
